module.exports = __webpack_public_path__ + "static/media/imagemID.03db3adc.png";